import api from "../utils/api";
import { serviceError } from "../lib/serviceError";
import { getLeadID } from "../utils/storage";
import { IS_PERSONAL_LOAN_SELECTED } from "../Constants/constant";

class FinboxAPI {

  // Finbox Bank Connect API
  async finboxBankConnectAPI(accountGatorResponse) {
    try {
      const endpoint = "/customer_onboarding/finbox-bank-connect";
      const req = {
        ...accountGatorResponse,
        leadID: Number(localStorage.getItem("leadID")),
      };

      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Finbox Create URL
  async finboxcreateUrlAPI() {
    const host = window.location.href.split("/");
    try {
      const endpoint = "/customer_onboarding/finbox-create-url";
      const req = {
        leadID: getLeadID(),
        callBackUrl: host[0] + "//" + host[2] + "/finbox"
      };
      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }

  // Banking Surrogate
  async bankingSurrogateAPI() {
    const isPersonalLoanSelected = localStorage.getItem(IS_PERSONAL_LOAN_SELECTED) === 'true';
    try {
      const endpoint = "/customer_onboarding/banking-surrogate";
      const req = {
        leadId: getLeadID(),
        ...(isPersonalLoanSelected ? { isPL: true } : {})
      };
      const { data } = await api.post(endpoint, req);
      return data;
    } catch (error) {
      serviceError(error);
    }
  }
}

export default FinboxAPI;
